import React, { useState } from 'react';
import { Bug, X } from 'lucide-react';

/**
 * Floating Report Bug Button
 * Opens the user's default email client with a pre-filled bug report email
 */
const ReportBugButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  const handleClick = () => {
    const subject = encodeURIComponent('Bug Report - Match It Up');
    const body = encodeURIComponent(
      `Hi Match It Up Team,\n\nI found a bug:\n\n` +
      `**What happened:**\n[Describe the issue here]\n\n` +
      `**What I expected:**\n[What should have happened]\n\n` +
      `**Steps to reproduce:**\n1. \n2. \n3. \n\n` +
      `**Device/Browser:**\n${navigator.userAgent}\n\n` +
      `Thanks!`
    );
    
    window.location.href = `mailto:support@matchitup.in?subject=${subject}&body=${body}`;
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-4 sm:right-6 z-50 hidden sm:flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group"
      data-testid="report-bug-button"
      aria-label="Report a bug"
    >
      <Bug className="w-5 h-5" />
      <span 
        className={`overflow-hidden transition-all duration-300 whitespace-nowrap ${
          isHovered ? 'max-w-32 opacity-100' : 'max-w-0 opacity-0'
        }`}
      >
        Report Bug
      </span>
    </button>
  );
};

export default ReportBugButton;
